import React, { useEffect, useState } from 'react'
import { CallApi, CommonModal } from './CommonFunctions';
import { ReactComponent as SaveIcon } from "../../assets/images/save.svg";
import { Button, Form } from 'react-bootstrap';
import { SAVEHANDLER } from '../../Utils/conts';
import { toast } from 'react-toastify';

const AddStationHandler = ({ propData, modalClose, modalSubmit }) => {

    const [openModal, setOpenModal] = useState(false)
    const initInput = { handler_name: '', handler_org_id: '', address: '', handler_email_id: '', handler_phone_no: '' }
    const [inputAddress, setInputAddress] = useState(propData?.frmData || initInput);

    // useEffect(() => {
    //     setInputAddress(propData?.frmData)
    // },[propData])
    const handleAddressChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
    };

    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_name) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        else {
            return isValid;
        }
    };
    const handleSave = async (e) => {
        // console.log('444', inputAddress);
        if (validateFormData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            const stationid = propData.station_id;
            const NewInputAddress = { ...inputAddress, handler_contact_id: inputAddress.handler_contact_id ?? inputAddress.id, station_id: stationid };

            const dataToSend = {
                station_id: stationid,
                company_name: inputAddress.company_name,
                agent_or_handler: inputAddress.agent_or_handler,
                address: inputAddress.address,
                email: inputAddress.email,
                phone_number: inputAddress.phone_number
            };
            // console.log("🚀 ~ addAddress ~ dataToSend:", dataToSend)

            if (inputAddress.agent_or_handler === 'A') {
                dataToSend.agent_type = inputAddress.agent_type;
            }

            // const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                CallApi({
                    endPoint: SAVEHANDLER,
                    payload: NewInputAddress,
                    onSuccess: (res) => {
                        if (res.data.response_code == 200) {
                            // setAddress(res.data.response_data);
                            setInputAddress({
                                handler_org_id: '', address: '', handler_email_id: '', handler_phone_no: ''
                            });
                            modalSubmit(res.data.response_data)
                            modalClose();
                        } else {
                            toast.error(res.data.response_msg);
                        }
                    },
                    onError: (msg) => toast.error(msg)
                });

            }

        }
    }
    return (
        <CommonModal
            show={true}
            onHide={modalClose}
            title={propData?.title}
            subTitle={propData?.subTitle}
            className='addfrom primary_modal'
            footer={
                <div className='d-flex'>
                    {/* <Button variant="secondary" onClick={modalClose}> Discard </Button> */}
                    <Button variant="primary" onClick={handleSave} className="ms-auto"><SaveIcon /> Save </Button>
                </div>
            }>
            {/* {console.log('inputAddress', inputAddress)} */}
            <Form.Group className='mb-2'>
                <Form.Label>Handler Name <span className="red">*</span></Form.Label>
                <Form.Control
                    type="text"
                    onChange={handleAddressChange}
                    name='handler_name'
                    placeholder="Handler Name"
                    value={inputAddress?.handler_name || ''}
                />
            </Form.Group>
            <Form.Group className='mb-2'>
                <Form.Label>Contact Email ID  </Form.Label>
                <Form.Control
                    type="text"
                    placeholder="E-mail"
                    value={inputAddress?.handler_email_id || ''}
                    name='handler_email_id'
                    onChange={handleAddressChange}
                    className=""
                />
            </Form.Group>
            <Form.Group className='mb-2'>
                <Form.Label>Address </Form.Label>
                <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" value={inputAddress.address || ''} />
            </Form.Group>
            <Form.Group className='mb-2'>
                <Form.Label>Telephone No</Form.Label>
                <Form.Control
                    type="number"
                    onChange={handleAddressChange}
                    name='handler_phone_no'
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                    placeholder="Number"
                    value={inputAddress.handler_phone_no || ''}
                />
            </Form.Group>
        </CommonModal>
    )
}

export default AddStationHandler;